import React from 'react';
import '../styles/LiquidRoundButton.css'

const LiquidRoundButton = ({ 
  children, 
  className = '', 
  onClick, 
  disabled = false,
  type = 'button',
  ...props 
}) => {
  const baseClasses = 'LiqRoundButtBg';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  return (
    <div className="LiqRoundButtCont">
        <button
            type={type}
            onClick={onClick}
            className={combinedClasses}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    </div>
  );
};

export default LiquidRoundButton;